import type { B2bJoinOrganizationResponse } from '../../accounts/types/b2bAccount.types';

/**
 * Where to send the user after a successful POST /accounts/join.
 */
export function getPostB2bOrgJoinPath(result: B2bJoinOrganizationResponse | undefined): string {
  const groupId = result?.defaultCompetitionGroupId;
  const wcOk = result?.worldCupJoin == null || result.worldCupJoin.ok === true;
  if (typeof groupId === 'string' && groupId.length > 0 && wcOk) {
    return `/app/worldcup/groups/${groupId}`;
  }
  return '/app/worldcup/groups';
}
